import { render } from "./FrontendLayout.vue?vue&type=template&id=3e359552&ts=true"
import script from "./FrontendLayout.vue?vue&type=script&lang=ts"
export * from "./FrontendLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__